/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import {
    CompleteDeliveryOrderResponse,
    CreateDeliveryOrderResponse,
    DeliveryOrderHistoryResponse,
    DeliveryOrderLinkedOrdersApiResponse,
    GetDeliveryOrderByIdApiResponse,
    GetDeliveryOrdersByPOIdApiResponse,
    GetSingleDeliveryOrderByIdApiResponse,
} from "../../@types/DRO/DeliveryOrderResponse";
import {
    CreateDeliveryOrderBody,
    CreateDeliveryOrderRecievedBody,
} from "../../@types/DTO/CreateDeliveryOrderBody";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class DeliveryOrderApi {
  public static api = new DeliveryOrderApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getDeliveryOrderApi(
    page?: number,
    pageSize?: number,
    search?: string,
    startDate?: string,
    endDate?: string,
    status?: string
  ): Promise<GetDeliveryOrderByIdApiResponse> {
    try {
      const response: AxiosResponse<GetDeliveryOrderByIdApiResponse> =
        await this.instance.get("/erp/api/v1/delivery-order/all", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page,
            pageSize,
            search,
            startDate,
            endDate,
            status,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async createDeliveryOrder(
    orderBody: CreateDeliveryOrderBody
  ): Promise<CreateDeliveryOrderResponse> {
    try {
      const response: AxiosResponse<CreateDeliveryOrderResponse> =
        await this.instance.post(
          `/erp/api/v1/delivery-order/create`,
          orderBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }

  async createDeliveryOrderRecieved(
    orderBody: CreateDeliveryOrderRecievedBody,
    id: number
  ): Promise<CompleteDeliveryOrderResponse> {
    try {
      const response: AxiosResponse<CompleteDeliveryOrderResponse> =
        await this.instance.put(
          `/erp/api/v1/delivery-order/complete`,
          orderBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
            params: {
              id,
            },
          }
        );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getSingleDeliverOrderDetails(
    id: number | null
  ): Promise<GetSingleDeliveryOrderByIdApiResponse> {
    try {
      const response: AxiosResponse<GetSingleDeliveryOrderByIdApiResponse> =
        await this.instance.get(`/erp/api/v1/delivery-order/details/${id}`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async getDeliveryOrderHistory(id: number): Promise<DeliveryOrderHistoryResponse> {
    try {
      const response: AxiosResponse<DeliveryOrderHistoryResponse> =
        await this.instance.get(`/erp/api/v1/delivery-order/history`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            id,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery order history:", error);
      throw error;
    }
  }
  async getLinkedDObyId(
    id: number | null
  ): Promise<DeliveryOrderLinkedOrdersApiResponse> {
    try {
      const response: AxiosResponse<DeliveryOrderLinkedOrdersApiResponse> =
        await this.instance.get(`/erp/api/v1/delivery-order/linked/${id}`, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async getAllDeliveryOrderByPOId(
    purchaseOrderId: number | null
  ): Promise<GetDeliveryOrdersByPOIdApiResponse> {
    try {
      const response: AxiosResponse<GetDeliveryOrdersByPOIdApiResponse> =
        await this.instance.get(
          `/erp/api/v1/delivery-order/${purchaseOrderId}`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions all data", error);
      throw error;
    }
  }

  async createDeliveryOrderDraft(
    orderBody: CreateDeliveryOrderBody,
    id: number
  ): Promise<CreateDeliveryOrderResponse> {
    try {
      const response: AxiosResponse<CreateDeliveryOrderResponse> =
        await this.instance.put(
          `/erp/api/v1/delivery-order/update`,
          orderBody,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`,
            },
            params: {
              id,
            },
          }
        );
      return response.data;
    } catch (error) {
      console.error("Error creating purchase order", error);
      throw error;
    }
  }

  async updateDeliveryOrder(
    orderBody: CreateDeliveryOrderBody,
    id: number
  ): Promise<CreateDeliveryOrderResponse> {
    try {
      const response: AxiosResponse<CreateDeliveryOrderResponse> =
        await this.instance.put(`/erp/api/v1/delivery-order/update`, orderBody, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            id,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error updating delivery order", error);
      throw error;
    }
  }
}
